import { Helmet } from 'react-helmet'
import { useSession } from 'contexts/session-context'
import useRouter from 'hooks/use-router'
import useRedirect from 'hooks/use-redirect'
import ComingNextSection from 'views/neighbars/components/ComingNextSection'
import CtaVideoSection from 'views/neighbars/components/CtaVideoSection'
import Hero from './components/Hero'
import AboutSection from './components/AboutSection'
import ReviveSection from './components/ReviveSection'
import NextEditionSection from './components/NextEditionSection'
import UpcomingExperiences from './components/UpcomingExperiences'
import InsideSection from './components/InsideSection'
import MerchSection from './components/MerchSection'
import { AFTERWORK_WHATSAPP_URL } from './constants'

const SEO_TITLE = 'Afterwork | My Heineken'
const SEO_DESCRIPTION =
  'Heineken Afterwork: buena música, grandes conversaciones y una Heineken bien fría en los mejores venues de la ciudad. Participa por una invitación a la próxima edición.'

const Afterwork = () => {
  const [{ user }] = useSession()
  const { push, pathname } = useRouter()
  const [, { setRedirect }] = useRedirect()

  const isLogged = user !== undefined

  const goToStart = () => {
    setRedirect(pathname)
    push('/start')
  }

  const handleParticipate = () => {
    window.open(AFTERWORK_WHATSAPP_URL, '_blank', 'noopener')
  }

  return (
    <div className="afterwork">
      <Helmet>
        <title>{SEO_TITLE}</title>
        <meta name="description" content={SEO_DESCRIPTION} />
        <meta property="og:title" content={SEO_TITLE} />
        <meta property="og:description" content={SEO_DESCRIPTION} />
        <meta property="og:type" content="website" />
      </Helmet>
      <Hero />
      <AboutSection onCtaClick={handleParticipate} />
      <ReviveSection />
      <NextEditionSection onCtaClick={handleParticipate} />
      <UpcomingExperiences />
      <InsideSection />
      <MerchSection />
      <CtaVideoSection />
      <ComingNextSection showCta={!isLogged} onCtaClick={goToStart} trackSection="afterwork" />
    </div>
  )
}

export default Afterwork
